// import React, { useState } from "react";
// import "./ProductCard.css";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import AuthModal from "../../Auth/AuthModal";

// const ProductCard = ({ product }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [openAuthModal, setOpenAuthModal] = useState(false);
//   const [isAddingToCart, setIsAddingToCart] = useState(false);

//   if (!product) return null;

//   const {
//     title = "No Title",
//     brand = "No Brand",
//     discountedPrice = 0,
//     price = 0,
//     colorVariants = [],
//     rating = 5,
//     reviewCount = 85,
//     _id,
//   } = product;

//   const defaultVariant = colorVariants[0] || {};
//   const color = defaultVariant.color || "N/A";
//   const images = defaultVariant.images || [];
//   const frontImage = images.find((img) => img.label === "front")?.url;
//   const backImage = images.find((img) => img.label === "back")?.url;

//   const handleNavigate = () => {
//     navigate(`/product/${_id}`);
//   };

//   const handleClose = () => setOpenAuthModal(false);

//   const handleAddToCart = async (e) => {
//     e.stopPropagation();

//     const jwt = localStorage.getItem("jwt"); // ✅ Get fresh token at click time

//     if (!jwt) {
//       setOpenAuthModal(true);
//       return;
//     }

//     if (!_id) {
//       toast.error("Product not found");
//       return;
//     }

//     setIsAddingToCart(true);

//     try {
//       const data = {
//         productId: _id,
//         size: "ONE_SIZE",
//         quantity: 1,
//       };

//       await dispatch(addItemToCart({ data, jwt }));
//       dispatch({ type: "TRIGGER_SIDEBAR_RELOAD" });
//       dispatch({ type: "CLEAR_CART_SIDEBAR_STEPS" })

//       toast.success("Item added to cart!");
//     } catch (error) {
//       toast.error("Failed to add to cart");
//       console.error("Add to cart error:", error);
//     } finally {
//       setIsAddingToCart(false);
//     }
//   };

//   return (
//     <>
//       <div
//         onClick={handleNavigate}
//         className="productCard w-[15rem] transition-all cursor-pointer"
//       >
//         <div>
//           <img
//             className="h-full w-full object-cover object-left-top  productImgs"
//             style={{ borderRadius: "15px" }}
//             src={frontImage || "/fallback.jpg"}
//             alt={title}
//           />
//         </div>

//         <div className="textPart bg-white p-3 text-sm sm:text-base flex flex-col justify-between space-y-2">
//           <div>
//             <p className="opacity-60 text-xs sm:text-sm">{brand}</p>
//             <p className="font-bold text-sm sm:text-base">{title}</p>
//           </div>

//           <div className="flex flex-wrap items-center my-2 gap-1 sm:gap-2">
//             <div className="flex">
//               {[...Array(5)].map((_, i) => (
//                 <svg
//                   key={i}
//                   className={`w-4 h-4 ${i < Math.floor(rating) ? "text-yellow-400" : "text-gray-300"}`}
//                   fill="currentColor"
//                   viewBox="0 0 20 20"
//                 >
//                   <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                 </svg>
//               ))}
//             </div>
//             <span className="ml-2 text-gray-600 text-xs sm:text-sm reviewtext">
//               {reviewCount} reviews
//             </span>
//           </div>

//           <div className="flex space-x-2 items-center">
//             <span className="f-price-item f-price-item--regular text-base sm:text-lg">
//               From Rs. {discountedPrice}
//             </span>
//           </div>

//           <div className="addtocart mt-2">
//             <button
//               className="addtocartbtn w-full sm:w-auto text-sm sm:text-base"
//               onClick={handleAddToCart}
//               disabled={isAddingToCart}
//             >
//               {isAddingToCart ? "Adding..." : "Add To Cart"}
//             </button>
//             {/* <button
//               className="addtocartbtn w-full sm:w-auto text-sm sm:text-base"
//             >
//               Out Of Stock
//             </button> */}
//           </div>
//         </div>

//       </div>

//       {/* Auth modal for login */}
//       <AuthModal handleClose={handleClose} open={openAuthModal} />
//     </>
//   );
// };

// export default ProductCard;


import React, { useState } from "react";
import "./ProductCard.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthModal from "../../Auth/AuthModal";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  if (!product) return null;

  const {
    title = "No Title",
    brand = "No Brand",
    discountedPrice = 0,
    price = 0,
    colorVariants = [],
    rating = 5,
    reviewCount = 85,
    _id,
    quantity = 0, // ✅ Add quantity check
  } = product;

  const defaultVariant = colorVariants[0] || {};
  const color = defaultVariant.color || "N/A";
  const images = defaultVariant.images || [];
  const frontImage = images.find((img) => img.label === "front")?.url;
  const backImage = images.find((img) => img.label === "back")?.url;

  const handleNavigate = () => {
    navigate(`/product/${_id}`);
  };

  const handleClose = () => setOpenAuthModal(false);

  const handleAddToCart = async (e) => {
    e.stopPropagation();

    const jwt = localStorage.getItem("jwt"); // ✅ Get fresh token at click time

    if (!jwt) {
      setOpenAuthModal(true);
      return;
    }

    if (!_id) {
      toast.error("Product not found");
      return;
    }

    setIsAddingToCart(true);

    try {
      const data = {
        productId: _id,
        size: "ONE_SIZE",
        quantity: 1,
      };

      await dispatch(addItemToCart({ data, jwt }));
      dispatch({ type: "TRIGGER_SIDEBAR_RELOAD" });
      dispatch({ type: "CLEAR_CART_SIDEBAR_STEPS" });

      toast.success("Item added to cart!");
    } catch (error) {
      toast.error("Failed to add to cart");
      console.error("Add to cart error:", error);
    } finally {
      setIsAddingToCart(false);
    }
  };

  return (
    <>
      <div
        onClick={handleNavigate}
        className="productCard w-[15rem] transition-all cursor-pointer"
      >
        <div>
          <img
            className="h-full w-full object-cover object-left-top productImgs"
            style={{ borderRadius: "15px" }}
            src={frontImage || "/fallback.jpg"}
            alt={title}
          />
        </div>

        <div className="textPart bg-white p-3 text-sm sm:text-base flex flex-col justify-between space-y-2">
          <div>
            <p className="opacity-60 text-xs sm:text-sm">{brand}</p>
            <p className="font-bold text-sm sm:text-base">{title}</p>
          </div>

          <div className="flex flex-wrap items-center my-2 gap-1 sm:gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className={`w-4 h-4 ${i < Math.floor(rating) ? "text-yellow-400" : "text-gray-300"
                    }`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            <span className="ml-2 text-gray-600 text-xs sm:text-sm reviewtext">
              {reviewCount} reviews
            </span>
          </div>

          <div className="flex space-x-2 items-center">
            <span className="f-price-item f-price-item--regular text-base sm:text-lg">
              From Rs. {discountedPrice}
            </span>
          </div>

          <div className="addtocart mt-2">
            {quantity > 0 ? (
              <button
                className="addtocartbtn w-full sm:w-auto text-sm sm:text-base"
                onClick={handleAddToCart}
                disabled={isAddingToCart}
              >
                {isAddingToCart ? "Adding..." : "Add To Cart"}
              </button>
            ) : (
              <button
                className="addtocartbtn w-full sm:w-auto text-sm sm:text-base bg-gray-400 cursor-not-allowed"
                disabled
              >
                Out Of Stock
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Auth modal for login */}
      <AuthModal handleClose={handleClose} open={openAuthModal} />
    </>
  );
};

export default ProductCard;
